export var utilsMixin = {
    data() {
        return {
            belgeIadeSebebi: '',
            iadeSebepler: [
                {name: 'Belgeyi Okuyamadım'},
                {name: 'Yabancı Belge'}
            ]
        }
    },
    methods: {
        belgeIadeModalAc() {
            this.$refs.belgeIadeModal.show();
            this.belgeIadeSebebi = this.iadeSebepler[0].name
        },
        belgeIadeSonucKontrol(res, tur) {
            if (res.kod === "iptaltamamlandı") {
                this.$notify({
                    group: 'ust',
                    title: 'İade',
                    text: "İade talebiniz işlendi."
                });
                setTimeout(async () => {
                    this.$destroy();
                    try {
                        await this.$router.push("belgeler?ne=sahsi&tur=" + tur);
                    } catch (e) {
                        window.location.reload();
                    }
                }, 3000);
            } else {
                this.$notify({
                    group: 'ust',
                    title: 'İade',
                    type: 'error',
                    text: res.mesaj
                });
            }
        },
        iadeVazgeceTikladi() {
            this.belgeIadeSebebi = ""
        },
        intToDurumString(i) {
            i = Number(i);
            if (i === 0)
                return 'Bekliyor';
            if (i === 1)
                return 'Tamamlandı';
            if (i === 2)
                return 'İnceleniyor';
            if (i === 3)
                return 'Düzenlemede';
            if (i === 4)
                return 'Onaya Gönderildi';

            return 'Hepsi';

        },
        intToIslemString(i) {
            i = Number(i);
            if (i === 0)
                return 'Bekliyor';
            if (i === 1)
                return 'Düzenleniyor';
            if (i === 2)
                return 'Onaya Gönderildi';
            if (i === 3)
                return 'Red';
            if (i === 4)
                return 'Tamamlandı';

            return 'Hepsi';
        },
        isimGetir(kisi) {
            if (!kisi)
                return "-";

            if (!kisi.isim)
                return kisi;

            /*if (!kisi.bayanMi)
                return kisi.isim;*/

            const str = kisi.isim.split(' ');

            for (let i = 0; i < str.length - 1; i++)
                str[i] = str[i][0] + ".";

            return str.join(' ');
        }
    }
};